import { RecorderType } from "utils/RecorderUtil";
import { CommonResponse } from "./commonInterface.interface";
import { HelpGuide } from "hook/useHelpGuideApi";
import { ADMINUNLOCK_MODEL } from "./helpInterface.interface";

export enum VIDEO_GUIDE_TYPE {
  GROUP,
  YOUTUBE,
  PDF,
}

export enum FIRMWARE_FEATURE_KEY {
  FIRMWARE_UPGRADE = "FIRMWARE_UPGRADE",
  COVERT_CAMERA = "COVERT_CAMERA",
  COVA_CONFIG_DOWNLOAD = "COVA_CONFIG_DOWNLOAD",
  ADMIN_UNLOCK = "ADMIN_UNLOCK",
}

export enum COVA_MODEL {
  DW_COVA4 = "DW_COVA4xT_DW_COVA8xT",
  DW_COVA16 = "DW_COVA16xT",
}

type FirmwareModel = COVA_MODEL | ADMINUNLOCK_MODEL;

export interface FirmwareVersionInfoRequest {
  featureKey: FIRMWARE_FEATURE_KEY;
  displayType: RecorderType;
  model?: FirmwareModel;
  option?: string;
}

export interface FirmwareVersionInfoResponse extends CommonResponse {
  result: {
    featureKey: FIRMWARE_FEATURE_KEY;
    displayType: RecorderType;
    model: string;
    option: string;
    minVersion: string;
    supported: boolean;
  };
}

export interface SelectGroup {
  category: string;
  groupId: string;
  groupName: string;
  layout?: string;
  position?: number;
}

export interface SelectedCategory {
  categoryId: string;
  categoryName: string;
}

export interface VideoGuideCategory {
  categoryId: string;
  name: string;
  order: number;
  parentCategoryId: string;
}

export type VideoModalState = {
  groupAdd: boolean;
  groupEdit: boolean;
  videoAdd: boolean;
  videoEdit: boolean;
  pdfAdd: boolean;
  pdfEdit: boolean;
  deleteConfirm: boolean;
};
export interface VideoGuideSetting {
  id: string;
  title: string;
  videoUrl: string;
  thumbnailUrl: string;
  description: string;
  position: number;
  groupId: string;
  resourceType: string;
  fileName?: string;
}

export interface TroubleSummit {
  id: string;
  createAt: string;
  name: string;
  email: string;
  accountName: string;
  accountNumber: string;
  accountLevel: string;
  status: string;
}

export interface VideoGuideVideo {
  id: string;
  title: string;
  videoUrl: string;
  thumbnailUrl?: string;
  description: string;
  position?: number;
}

export interface VideoGuideGroup {
  groupId: string;
  name: string;
  position: number;
  category: string;
  videoGuideList: HelpGuide[];
  layout?: string;
}

export interface GetVideoGuideCategoryListResponse extends CommonResponse {
  result: {
    [categoryName: string]: VideoGuideGroup[];
  };
}

export interface GetVideoGuideGroupListResponse extends CommonResponse {
  result: VideoGuideGroup[];
}

export interface GetVideoGuideListResponse extends CommonResponse {
  result: VideoGuideSetting[];
}

export interface VideoGuideGroupDto {
  category: string;
  groupId?: string;
  name: string;
  position?: number;
  layout?: string;
}

export interface VideoGuideVideoDto {
  groupId: string;
  groupName?: string;
  id?: string;
  title: string;
  videoUrl: string;
  thumbnailUrl?: string;
  description: string;
  position?: number;
  fileName?: string;
}

export interface VideoGuidePdfDto extends HelpGuide {
  groupId: string;
  groupName?: string;
  title: string;
  file?: File;
}

export interface FirmwareUpgradeDto {
  isEnabled: boolean;
  updateTime: string;
  notifyPush: boolean;
  notifyEmail: boolean;
}

export interface FirmwareUpgradeDtoResponse extends CommonResponse {
  result: FirmwareUpgradeDto;
}
